import OrganizationDomain from "./OrganizationDomain"

export default OrganizationDomain
